export default __webpack_public_path__ + "static/media/default_project_thumbnail.2b3a3f28.png";